// extracted by mini-css-extract-plugin
export default {"page":"layout_page__9tEPT","main":"layout_main__NS9px","iconProfile":"layout_iconProfile__19+XC","profileAnimate":"layout_profileAnimate__4ZIHu"};